import axios from 'axios'
import {
  CREATE_USER,
  GET_ALL_ROLES,
  GET_ALL_USERS,
  UPDATE_USER,
} from '../constants/endpoints'
import KeycloakService from '../utils/keycloakService'

export const getUsers = async (
  query: string,
  page: number,
  size: number,
  searchTerm?: string
) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_USERS}?q=${query}&q2=${searchTerm}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const createUser = async (userData: any) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_USER}`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error creating user: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const updateUser = async (userId: string | number, userData: any) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPDATE_USER}?userId=${userId}`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error creating user: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getAllRoles = async () => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_ROLES}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    // console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
